var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReservation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#F0B70D",
    fill: "#FFF",
    cx: 24,
    cy: 24,
    r: 24
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#F3B229"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.074 18.5v12.113h-5.382L13.5 26.91c.789-.192 1.33-.434 1.721-.826a2.156 2.156 0 0 0 0-3.058 2.156 2.156 0 0 0-1.529-.634l-.192-3.7 5.574-.193zM34.308 18.5l.192 3.701c-.789.192-1.33.435-1.721.826a2.156 2.156 0 0 0 0 3.058c.392.392.932.634 1.529.634l.192 3.701-13.042.193V18.5h12.85z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservation);
export default __webpack_public_path__ + "static/media/reservation.82c08544360d8821e29045c4d66a902a.svg";
export { ForwardRef as ReactComponent };